import { Modal } from '@mantine/core';

import ModalFolderCards from './modalFolderCards';

import useGetFolders from '../../hooks/useGetFolders';
import PrimaryButton from 'components/primaryButton';
import SecondaryButton from 'components/secondaryButton';
import { useEffect, useState } from 'react';
import ModalSubFolders from './modalSubFolders';

import useMoveFilesAndFolder from '../../hooks/useMoveFilesAndFolders';
import useCopyFilesAndFolder from '../../hooks/useCopyFilesAndFolders';
import AddNewFolderModal from './addnewfolderModal';
import FailToMoveModal from './failToMoveModal';
import { useLocation } from 'react-router-dom';

const MoveFilesOrFolders = ({
  moveFilesModal,
  setMoveFilesModal,
  path,
  copyOrMove,
  setCopyOrMove,
}) => {
  const foldersData = useGetFolders();
  const location = useLocation();

  const [selectedId, setSelectedId] = useState(null);
  const [historyOfPath, setHistoryOfPath] = useState();
  const [mainPath, setMainPath] = useState(null);
  const [newFolderModal, setNewFolderModal] = useState(false);
  const [message, setMessage] = useState('');
  const [isCopy, setIsCopy] = useState(false);

  const closeModal = () => {
    setMoveFilesModal(false);
    setSelectedId(false);
    setHistoryOfPath(false);
    setMainPath(false);
    setCopyOrMove(null);
    setFailtoMoveData([]);
    setFailToMoveModal(false);
    setIsCopy(false);
  };

  const moveFilesAndFoldersMutation = useMoveFilesAndFolder(setMessage);
  const copyFilesAndFoldersMutation = useCopyFilesAndFolder(setMessage);

  const customTitle = () => {
    return (
      <div className='relative flex justify-center items-center text-xl mx-4 my-4'>
        {/* <LeftArrowIcon
          onClick={() => {
            setMoveFilesModal(false);
            // closeModal();
          }} */}
        {/* className='w-4 absolute left-0 cursor-pointer'
        /> */}
        <p>{copyOrMove === 'Copy' ? 'Copy to' : 'Move to'} </p>
      </div>
    );
  };

  const [failTOMoveData, setFailtoMoveData] = useState([]);
  const [failToMoveModal, setFailToMoveModal] = useState(false);

  useEffect(() => {
    if (moveFilesAndFoldersMutation?.data?.data.length === 0) {
      closeModal();
      return;
    }

    if (moveFilesAndFoldersMutation?.isError) {
      setFailToMoveModal(true);
      setFailtoMoveData(path);
    }

    // eslint-disable-next-line
  }, [
    moveFilesAndFoldersMutation?.isSuccess,
    moveFilesAndFoldersMutation?.isError,
  ]);
  // console.log('moveFilesAndFoldersMutation', moveFilesAndFoldersMutation);

  const handleMove = () => {
    moveFilesAndFoldersMutation.mutate({
      files: path,
      to: historyOfPath,
    });
  };
  useEffect(() => {
    if (copyFilesAndFoldersMutation?.data?.data?.length === 0) {
      closeModal();
      return;
    }
    if (copyFilesAndFoldersMutation?.isError) {
      setFailToMoveModal(true);
      setIsCopy('true');
      setFailtoMoveData(path);
    }

    // eslint-disable-next-line
  }, [
    copyFilesAndFoldersMutation?.isSuccess,
    copyFilesAndFoldersMutation?.isError,
  ]);
  // console.log('copyFilesAndFoldersMutation:', copyFilesAndFoldersMutation);
  return (
    <>
      <Modal
        opened={moveFilesModal}
        onClose={closeModal}
        title={customTitle()}
        withCloseButton={false}
        overlayColor={'#F8F7F799'}
        overlayBlur={20}
        overlayOpacity={0.5}
        centered
        size={1200}
        radius='md'
        overflow='inside'
        transitionDuration={100}
        classNames={{
          title: 'w-full  font-semibold text-18',
          modal: 'pl-10',
          body: 'scroller -mr-4 pr-2  min-h-[65vh]',
        }}
      >
        {!historyOfPath ? (
          <>
            <div className='flex '>
              <button
                className='ml-auto pr-7'
                onClick={() => {
                  setNewFolderModal(true);
                }}
              >
                <PrimaryButton>+ New Folder</PrimaryButton>
              </button>
            </div>
            <div className='grid grid-cols-3 gap-3 w-full px-4 my-4 '>
              {foldersData?.data?.data?.map((eachFolder) => (
                <div key={eachFolder?.id}>
                  <ModalFolderCards
                    folder={eachFolder}
                    selectedId={selectedId}
                    setSelectedId={setSelectedId}
                    historyOfPath={historyOfPath}
                    setHistoryOfPath={setHistoryOfPath}
                    setMainPath={setMainPath}
                  />
                </div>
              ))}
            </div>
          </>
        ) : (
          <ModalSubFolders
            historyOfPath={historyOfPath}
            setHistoryOfPath={setHistoryOfPath}
            mainPath={mainPath}
            setMainPath={setMainPath}
            setSelectedId={setSelectedId}
          />
        )}
        <div className='flex justify-center items-center gap-4 my-8'>
          <button type='button' onClick={() => setMoveFilesModal(false)}>
            <SecondaryButton>Cancel</SecondaryButton>
          </button>
          {location?.state?.path !== historyOfPath && (
            <>
              {!selectedId ? null : (
                <button
                  className='w-32'
                  onClick={() => {
                    if (copyOrMove === 'Move') {
                      handleMove();
                    } else if (copyOrMove === 'Copy') {
                      copyFilesAndFoldersMutation.mutate({
                        files: path,
                        to: historyOfPath,
                      });
                    }
                  }}
                >
                  <PrimaryButton
                  // isLoading={
                  //   moveFilesAndFoldersMutation?.isLoading ||
                  //   copyFilesAndFoldersMutation?.isLoading
                  // }
                  >
                    {copyOrMove === 'Copy' ? 'Copy Here' : 'Move Here'}
                  </PrimaryButton>
                </button>
              )}
            </>
          )}
        </div>
      </Modal>
      <AddNewFolderModal
        newFolderModal={newFolderModal}
        setNewFolderModal={setNewFolderModal}
      />
      <FailToMoveModal
        failTOMoveData={failTOMoveData}
        setFailtoMoveData={setFailtoMoveData}
        failToMoveModal={failToMoveModal}
        setFailToMoveModal={setFailToMoveModal}
        closeModal={closeModal}
        historyOfPath={historyOfPath}
        message={message}
        isCopy={isCopy}
      />
    </>
  );
};

export default MoveFilesOrFolders;
